import { Dialog, DialogContent, DialogActions, Button, Stack } from "@mui/material";
import { bhpButtonSx } from "../../styles/bhpStyles";
import { DialogTitleClosable } from "../DialogTitleClosable";
import packageInfo from './../../../package.json';
import InfoIcon from '@mui/icons-material/Info';


type AboutDialogProps = {

    dialogOpen: boolean;
    handleOk: ( ) => void;

};


export const AboutDialog : React.FC< AboutDialogProps > = ( props : AboutDialogProps ) => {

    const { dialogOpen, handleOk } = props;


    const handleClose = ( ) => handleOk( );


    const handleOkClick = ( ) => handleOk( );


    return(

        <Dialog
            onClose={ handleClose }
            open={ dialogOpen }
            sx={{ '& .MuiDialog-paper': { maxHeight: 435, width: '500px' } }}
        >
            <DialogTitleClosable onClose={ handleClose }>
                <Stack direction="row" display="flex" alignItems="center" gap={ 0.5 }>
                    <InfoIcon /> Village Rules Portal
                </Stack>
            </DialogTitleClosable>

            <DialogContent dividers>
                
                <ul>

                    <li>Environment: { process.env.REACT_APP_ENVIRONMENT }</li>
                    <li>Version: { packageInfo.version }</li>

                </ul>

            </DialogContent>
            <DialogActions>
                <Button onClick={ handleOkClick } sx={{ ...bhpButtonSx, width: '100px' }} >
                    Ok
                </Button>
            </DialogActions>

        </Dialog>

    );



};